import React, { FC, useState, useEffect } from '../../../lib/teact/teact';
import buildClassName from '../../../util/buildClassName';
import styles from './TokenPill.module.scss'; // Assuming styles are shared here

export const getColorForSymbol = (symbol: string = '') => {
  const colors = ['#E57373', '#F06292', '#BA68C8', '#9575CD', '#7986CB', '#64B5F6', '#4FC3F7', '#4DD0E1', '#4DB6AC', '#81C784', '#AED581', '#FF8A65', '#D4E157', '#FFD54F', '#FFB74D', '#A1887F', '#90A4AE'];
  let hash = 0;
  for (let i = 0; i < symbol.length; i++) {
    hash = symbol.charCodeAt(i) + ((hash << 5) - hash);
  }
  return colors[Math.abs(hash) % colors.length];
};

export const TokenFallbackIcon: FC<{ symbol?: string; name?: string; className: string; isLarge?: boolean }> = ({ symbol, name, className, isLarge }) => {
  const displayChar = (symbol && symbol !== 'Unknown' ? symbol[0] : (name ? name[0] : '?')).toUpperCase();
  const bgColor = getColorForSymbol(symbol || name || '?');
  
  return (
    <div 
      className={buildClassName(className, styles.fallbackIcon, isLarge && styles.fallbackIconLarge)} 
      style={`background-color: ${bgColor};`}
    >
      {displayChar}
    </div>
  );
};

export const TokenIcon: FC<{ data: any; className: string; isLarge?: boolean }> = ({ data, className, isLarge }) => {
  const [error, setError] = useState(false);
  
  // Reset error state if imageUrl changes
  useEffect(() => {
    setError(false);
  }, [data.imageUrl]);
  
  if (data.imageUrl && !error) {
    return (
      <img 
        src={data.imageUrl} 
        className={className} 
        alt="" 
        draggable={false} 
        onError={() => setError(true)} 
      />
    );
  }
  
  return <TokenFallbackIcon symbol={data.symbol} name={data.name} className={className} isLarge={isLarge} />;
};
